import { render, staticRenderFns } from "./WebsiteOrderDetail.vue?vue&type=template&id=63e5fc8e&scoped=true&"
import script from "./WebsiteOrderDetail.vue?vue&type=script&lang=js&"
export * from "./WebsiteOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteOrderDetail.vue?vue&type=style&index=0&id=63e5fc8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5fc8e",
  null
  
)

export default component.exports